export const createErrorWithObj = ({ message = '', obj = {} } = {}) => {
  const error = new Error(message);

  return Object.assign(error, obj);
};